/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysStockMoveCreateDialog from "../dialogTypes/MomSysStockMoveCreateDialog";

function MomSysStockMoveCreateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, selectMstGrid, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    
    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
        console.log('refresh')
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"append-button"} onClick={onOpen} {...others} />
            <MomSysStockMoveCreateDialog
                id={id+"append-dialog"}
                title={t(`dialog.title.${schema.name}.create`)}
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>
    );
}

export default MomSysStockMoveCreateButton;

